import { useRef, useState } from "react";
import ConfirmModal from "../components/ConfirmModal";
import { useEffect } from "react";

import axios from "../axiosSetup";
import { Button, message ,Spin } from "antd";

export default function UploadCSVButton({
  apiEndpoint,
  onSuccess,
  onUploadError,
  uploadMode,
  file,
}) {
  const fileInputRef = useRef(null);

  const handleClick = () => {
  if (!file) {
    message.warning("Please select a file first");
    return;
  } 
  setConfirmOpen(true);   
};
const [errorModal, setErrorModal] = useState({
  open: false,
  messages: [],
});
const [errorModalOpen, setErrorModalOpen] = useState(false);
const [errorContent, setErrorContent] = useState(null);
const [confirmOpen, setConfirmOpen] = useState(false);
const resetFileInput = () => {
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};


const [uploading, setUploading] = useState(false);


  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const isCsvExtension = file.name.toLowerCase().endsWith(".csv");

  const isCsvMime =
    file.type === "text/csv" ||
    file.type === "application/vnd.ms-excel" ||
    file.type === "";

  if (!isCsvExtension || !isCsvMime) {
    alert("Only CSV files (.csv) are allowed.");
    resetFileInput();
    return;
  }

  const maxSize = 2 * 1024 * 1024;

  if (file.size >= maxSize) {
    alert("File size must be less than 2MB.");
    resetFileInput();
    return;
  }

  setConfirmOpen(true);
};
const handleConfirmUpload = async () => {
  if (!file) return;

  const formData = new FormData();
  formData.append("file", file);

  try {
    setUploading(true);

    await axios.post(apiEndpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    });

    message.success(
  uploadMode === "unmap"
    ? "Products unmapped successfully"
    : "Products mapped successfully"
);

    onSuccess && onSuccess();

  } catch (err) {
    console.error("Upload Error:", err);
    onUploadError && onUploadError(err);

    // 🔴 NETWORK ERROR
    if (!err.response) {
      setErrorContent(
        <div style={{ padding: "10px" }}>
          Network error. Please check your internet connection.
        </div>
      );
      setErrorModalOpen(true);
      return;
    }

    // 🔴 TIMEOUT
    if (err.code === "ECONNABORTED") {
      setErrorContent(
        <div style={{ padding: "10px" }}>
          Request timeout. Please try again.
        </div>
      );
      setErrorModalOpen(true);
      return;
    }

    const status = err.response.status;
    const data = err.response.data;

    if (status === 401) {
      alert("Session expired. Please login again.");
      return;
    }

    if (status === 413) {
      alert("File too large.");
      return;
    }

    let backendMessages = [];

    // 🔥 SAME LOGIC YOU HAD (moved correctly)
    if (Array.isArray(data?.details)) {
      backendMessages = data.details.map(item =>
        typeof item === "object"
          ? item.message || JSON.stringify(item)
          : item
      );
    } else if (typeof data?.details === "string") {
      backendMessages = [data.details];
    } else if (Array.isArray(data?.warnings)) {
      backendMessages = data.warnings;
    } else if (Array.isArray(data?.errors)) {
      backendMessages = data.errors;
    } else if (typeof data?.error === "object") {
      backendMessages = [
        data.error.message || JSON.stringify(data.error)
      ];
    } else if (typeof data?.error === "string") {
      backendMessages = [data.error];
    } else if (typeof data?.message === "string") {
      backendMessages = [data.message];
    } else {
      backendMessages = ["Unexpected error occurred."];
    }

    setErrorContent(
      <div
        style={{
          maxHeight: "300px",
          overflowY: "auto",
          whiteSpace: "pre-wrap",
          lineHeight: "1.6",
        }}
      >
        {backendMessages.map((msg, index) => (
          <div key={index}>• {msg}</div>
        ))}
      </div>
    );

    setErrorModalOpen(true);

  } finally {
    setUploading(false);
    setConfirmOpen(false);
    resetFileInput();
  }
};

  return (
    <>
    <Spin spinning={uploading} fullscreen></Spin>
      <Button
  onClick={handleClick}
  className="price-add-btn"
  disabled={uploading}
>
  {uploading ? (
    <>
      <Spin size="small" style={{ marginRight: 8 }} />
      Uploading...
    </>
  ) : (
    "Upload CSV"
  )}
</Button>


      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <ConfirmModal
  open={errorModalOpen}
  title="CSV Validation Errors"
  message={errorContent}
  confirmText="OK"
  cancelText="Cancel"
  confirmType="primary"
  onConfirm={() => {
    setErrorModalOpen(false);
    resetFileInput();  // ✅ allow immediate re-upload
  }}
  onCancel={() => {
    setErrorModalOpen(false);
    resetFileInput();  // ✅ allow immediate re-upload
  }}
/>

<ConfirmModal
  open={confirmOpen}
        title={
  uploadMode === "unmap"
    ? "Confirm Unmapping"
    : "Confirm Mapping"
}

        message={
          uploadMode === "unmap"
            ? "Are you sure you want to unmap the products from customers?"
            : "Are you sure you want to map the products to customers?"
        }
  onConfirm={handleConfirmUpload}
  onCancel={() => {
    setConfirmOpen(false);
    resetFileInput();
  }}
/>

    </>
    
  );
}
